import React from "react";
import useChartInDialogStore from "store/chart-in-dialog-store";

interface ChartInDialogButtonProps {
  identifier: string;
  identifiers?: string[];
  dateFrom?: Date;
  dateTo?: Date;
  header?: string;
}

const ChartInDialogButton = ({
  identifier,
  identifiers,
  dateFrom,
  dateTo,
  header,
}: ChartInDialogButtonProps) => {
  const { setDialogVisibility, setDateFrom, setDateTo, setHeader, setIdentifier, setIdentifiers } =
    useChartInDialogStore();

  const openDialog = () => {
    setIdentifier(identifier);
    setIdentifiers(identifiers || [identifier]);
    setDateFrom(dateFrom || new Date());
    setDateTo(dateTo || new Date());
    setHeader(header || "Chart");
    setDialogVisibility(true);
  };

  return (
    <i
      className="pi pi-chart-line"
      onClick={e => {
        if (!e.ctrlKey) {
          openDialog();
        }
      }}
      style={{ cursor: "pointer" }}
    />
  );
};

export default ChartInDialogButton;
